<template>
    <v-input-text
        v-model="inputValue"
        :label="label"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        :caption="caption"
        :autocomplete="autocomplete"
        :error="error"
        :name="name"
        :theme="theme"
        @keyup.enter.native="handleSearch"
    >
        <template slot="assistant-action" scope="props">
            <v-icon-button @click="handleSearch">
                search
            </v-icon-button>
        </template>
    </v-input-text>
</template>

<script>
    import { vButton } from '../Button';
    import { vInputText } from '../InputText';

    export default {
        name: 'input-search',
        components: {
            vInputText,
            vButton,
        },
        props: {
            auto: Boolean,
            value: [String, Number],
            label: String,
            placeholder: String,
            readonly: Boolean,
            disabled: Boolean,
            autocomplete: String,
            caption: String,
            error: String,
            name: String,
            maxlength: String,
            theme: Object
        },
        data() {
            return {
                inputValue: this.value,
            }
        },
        watch: {
            value(newValue) {
                if (this.inputValue !== newValue) {
                    this.inputValue = newValue;
                }
            },
            inputValue(newInputValue) {
                if (this.auto) {
                    this.$emit('input', newInputValue);
                }
            }
        },
        methods: {
            handleSearch() {
                this.$emit('input', this.inputValue);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// InputSearch.vue?7c98ad4c